module.exports = __webpack_public_path__ + "img/partly-cloudy-day.13a64e56.png";